import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={208.802}
      height={28.936}
      viewBox="0 0 208.802 28.936"
      {...props}
    >
      <defs>
        <style>{`.prefix__cls-1{fill:${props.fill} !important}`}</style>
      </defs>
      <g id="prefix__Group_7" transform="translate(-6.202 -530.724)">
        <path
          id="prefix__Rectangle_6"
          d="M0 0h8.673v28.017H0z"
          className="prefix__cls-1"
          transform="translate(6.202 531.183)"
        />
        <path
          id="prefix__Path_10"
          d="M84.647 542.285a8 8 0 012.613-1.425 10.39 10.39 0 013.27-.5h14.448l5.613-7.288H90.53a22.15 22.15 0 00-6.741.986 16.018 16.018 0 00-5.343 2.8 13.277 13.277 0 00-3.519 4.356 12.254 12.254 0 00-1.276 5.593 12.759 12.759 0 001.276 5.674A13.863 13.863 0 0078.446 557a16.631 16.631 0 005.343 3 20.255 20.255 0 006.741 1.087h19.223v-17.505H91.827l-5.195 6.241h14.488v4.066H90.53a10.725 10.725 0 01-3.31-.487 8.089 8.089 0 01-2.621-1.358 6.02 6.02 0 01-2.324-4.857 5.937 5.937 0 01.628-2.742 6.763 6.763 0 011.744-2.16z"
          className="prefix__cls-1"
          transform="translate(-54.257 -1.889)"
        />
        <path
          id="prefix__Path_11"
          d="M299.214 531.717a5.914 5.914 0 00-6.458 0 9.685 9.685 0 00-2.215 2.175l-17.967 25.336h10.261l2.992-4.235h20.318l2.992 4.235H319.4l-17.97-25.336a9.681 9.681 0 00-2.216-2.175zm-9.227 17.393l6-8.477 6 8.477z"
          className="prefix__cls-1"
          transform="translate(-214.275 -.027)"
        />
        <path
          id="prefix__Path_12"
          d="M559.032 531.663a4.958 4.958 0 00-2.951-.939 4.814 4.814 0 00-2.87.817 6.473 6.473 0 00-1.911 2.159l-4.479 7.957q-.922 1.632-1.614 2.85a90.41 90.41 0 00-2.134 3.963c-.262.52-.513 1.026-.736 1.526-.251-.5-.506-1.02-.777-1.547s-.567-1.121-.919-1.763-.749-1.371-1.215-2.2-.993-1.783-1.608-2.871l-4.484-7.916a6.131 6.131 0 00-1.9-2.175 4.831 4.831 0 00-2.823-.8 5.068 5.068 0 00-2.979.939 5.253 5.253 0 00-1.926 2.911l-7.24 24.627h8.5l2.641-9.76c.418-1.588.784-2.993 1.087-4.208s.574-2.377.8-3.492c.223.473.453.959.689 1.466s.521 1.054.838 1.648.675 1.283 1.067 2.033.838 1.608 1.344 2.553l3.769 7.079a7.218 7.218 0 001.108 1.655 4.981 4.981 0 001.148.946 3.78 3.78 0 001.257.438 10.613 10.613 0 002.931 0 3.726 3.726 0 001.256-.438 4.972 4.972 0 001.155-.946 7.425 7.425 0 001.108-1.655l3.769-7.032q1.428-2.725 2.3-4.505c.587-1.189 1.115-2.269 1.594-3.242.223 1.142.487 2.317.8 3.512s.683 2.6 1.129 4.188l2.64 9.76h8.626l-7.079-24.627a5.3 5.3 0 00-1.911-2.911z"
          className="prefix__cls-1"
          transform="translate(-410.466)"
        />
        <path
          id="prefix__Rectangle_7"
          d="M0 0h8.666v28.017H0z"
          className="prefix__cls-1"
          transform="translate(160.859 531.183)"
        />
        <path
          id="prefix__Path_13"
          d="M900.21 534.2q-5.137-3.475-15.352-3.478-10.255 0-15.367 3.478t-5.114 10.97q0 7.538 5.092 11.016t15.388 3.472q10.262 0 15.373-3.472t5.105-11.016q.001-7.496-5.125-10.97zm-4.126 14.63a4.677 4.677 0 01-2.033 2.2 9.871 9.871 0 01-3.661 1.067 56.615 56.615 0 01-11.058 0 9.954 9.954 0 01-3.667-1.067 4.707 4.707 0 01-2.026-2.2 11.009 11.009 0 010-7.328 4.617 4.617 0 012.026-2.176 10.26 10.26 0 013.667-1.047 56.819 56.819 0 0111.058 0 10.173 10.173 0 013.661 1.047 4.589 4.589 0 012.033 2.176 11.011 11.011 0 010 7.328z"
          className="prefix__cls-1"
          transform="translate(-690.333)"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
